/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- COMMUNITY TOP ARTICLES: STYLES --------------- ++++++++++ */
export default theme => ({
  toparticles: {
  '& .sectioncontent': {
      display: 'flex',
      flexFlow: 'row wrap',
      width: '100%',
      '& .control': {
        minWidth: pxToEm(64),
        maxWidth: pxToEm(64),
        flex: 1,
        flexBasis: '20%',
        marginBottom: pxToEm(8),
        marginRight: pxToEm(8)
      }
    }
  }
});
